<template>
    <div class="section-tags-list" v-if="items.length">
        <div class="main-description-title">Vinsæll búnaður</div>
        <div class="main-description-header main-description-header-block">
            <div class="main-description-header-tags-wrap" :class="{'less': !more}" ref="tags">
            <span v-for="(item, i) in getItems" :key="i" class="main-description-header-tag" ref="tag">
                <IconCheck/>
                <span>{{ item.name }}</span>
            </span>
            </div>
            <a v-if="needMore" @click.prevent="handleMore()" href="#" class="main-description-header-expand plas">
                {{buttonTitle}}
            </a>
        </div>
    </div>
</template>

<script>
    import IconCheck from "@/components/svg/check"

    export default {
        components: {
            IconCheck
        },
        props: {
            items: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            more: false,
            heightBlockTagsList: 0,
            heightBlockTag: 0
        }),
        mounted() {
            this.getHeightTags()
            this.getHeightTag()
        },
        methods: {
            handleMore() {
                this.more = !this.more;
                this.$emit('handleMore')
            },
            getHeightTags() {
                this.heightBlockTagsList = this.$refs.tags && this.$refs.tags.offsetHeight
            },
            getHeightTag() {
                if (!this.$refs.tag) return
                const tagMarginBottom = parseInt(window.getComputedStyle(this.$refs.tag[0]).marginBottom)
                this.heightBlockTag = this.$refs.tag[0].offsetHeight + tagMarginBottom
            }
        },
        computed: {
            needMore() {
                // return !this.more && this.heightBlockTagsList > this.heightBlockTag
                return this.items.length > 6
            },
            buttonTitle() {
                return this.more ? '- Sjá minna':'+ Sjá meira';
            },
          getItems(){
              return this.items.sort((a, b) => a.name.localeCompare(b.name));
          }
        }
    }
</script>
